import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as paymentMandateState from '../reducers';
import * as generatePaymentMandateReducer from '../reducers/generate-payment-mandate.reducer';

export const getGeneratedPaymentMandateRequest = createSelector(
  paymentMandateState.getGeneratePaymentMandateState,
  generatePaymentMandateReducer.getGeneratedPaymentMandateRequest
);
export const getGeneratedPaymentMandateResponse = createSelector(
  paymentMandateState.getGeneratePaymentMandateState,
  generatePaymentMandateReducer.getGeneratedPaymentMandateResponse
);
export const getGeneratedPaymentMandateIsLoaded = createSelector(
  paymentMandateState.getGeneratePaymentMandateState,
  generatePaymentMandateReducer.getGeneratedPaymentMandateIsLoaded
);

//Payment Mandate Accepted
export const getIsPaymentMandateAccepted = createSelector(
  paymentMandateState.getGeneratePaymentMandateState,
  generatePaymentMandateReducer.getIsPaymentMandateAccepted
);

//Get Card Details
export const getSavedCard = createSelector(paymentMandateState.getGeneratePaymentMandateState, generatePaymentMandateReducer.getSaveCard);
